import { Calendar, Download } from 'lucide-react';
import { motion } from 'motion/react';
import { useScrollAnimation, useCountUp } from '../hooks/useScrollAnimation';
// import lineArt from 'figma:asset/58d43eaea000361e7a16121bb8eb81d78fd46105.png';
// import fatLogo from 'figma:asset/a20c33ed61221ea5286cf45e17aa33dc3acd3900.png';
import { MessageCircle } from 'lucide-react';
 const bannerImage = new URL("../assets/bannerbg.png", import.meta.url).href;
 const lineArt = new URL("../assets/lineart.png", import.meta.url).href;


export const HeroSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.3);
  const stats = [
  { value: 15, label: 'Years of Experience', suffix: '+' },
  { value: 900 , label: 'International Clients', suffix: '+' },
  { value: 4000, label: 'Companies Incorporated', suffix: '+' },
  { value: 25, label: 'Legal Professionals', suffix: '+' },
];


  return (
    <section 
      id="home" 
      aria-label="Hero Section - Fahad Al Tamimi Law Firm"
      className="relative min-h-screen flex items-center bg-[#0a0a0a] overflow-hidden pt-20 lg:pt-0"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] lg:w-[800px] h-[400px] sm:h-[600px] lg:h-[800px] rounded-full bg-[#c3a565] opacity-[0.03] blur-[120px]"></div>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, delay: 0.8, ease: 'easeOut' }}
        className="hidden md:block absolute bottom-0 left-0 right-0 w-full h-24 md:h-36 pointer-events-none"
      >
        <div className="relative w-full h-full overflow-hidden">
          <motion.div
            initial={{ clipPath: 'inset(0 100% 0 0)' }}
            animate={{ clipPath: 'inset(0 0% 0 0)' }}
            transition={{ duration: 5, delay: 1.2, ease: [0.65, 0, 0.35, 1] }}
            className="relative w-full h-full"
          >
            <img
              src={lineArt}
              alt=""
              className="w-full h-full object-cover object-center opacity-25"
              style={{
                filter: 'invert(1) sepia(1) saturate(5) hue-rotate(10deg) brightness(0.85)',
                mixBlendMode: 'screen'
              }}
            />
          </motion.div>
          <motion.div
            initial={{ left: '-8%', opacity: 0 }}
            animate={{ left: '100%', opacity: [0, 1, 1, 0] }}
            transition={{ 
              duration: 5, 
              delay: 1.2, 
              ease: [0.65, 0, 0.35, 1],
              opacity: {
                times: [0, 0.08, 0.88, 1],
                duration: 5
              }
            }}
            className="absolute top-1/2 -translate-y-1/2 pointer-events-none z-20"
          >
            <div 
              className="text-[#c3a565] tracking-wider"
              style={{
                fontSize: '2.5rem',
                fontWeight: 700,
                textShadow: '0 0 20px rgba(195, 165, 101, 0.6), 0 0 40px rgba(195, 165, 101, 0.3)'
              }}
            >
              FAT
            </div>
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-transparent to-[#0a0a0a]"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/70 via-transparent to-transparent"></div>
        </div>
      </motion.div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32 w-full relative z-10 banner-section">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-20 items-center">
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="inline-flex items-center gap-2 bg-[#c3a565]/10 border border-[#c3a565]/30 rounded-full px-4 py-2 sm:px-5 sm:py-2.5 mb-6 sm:mb-8"
            >
            <div className="pulse"></div>
              <span className="text-xs sm:text-sm text-[#faf9f7]/90" style={{ fontWeight: 500 }}>
               Recognized Excellence for Legal Services in Saudi Arabia
              </span>
            </motion.div>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mb-4 sm:mb-6 text-[#faf9f7] text-3xl sm:text-4xl lg:text-5xl xl:text-6xl"
              style={{ 
                lineHeight: '1.1',
                fontWeight: 700
              }}
            >
             Your Trusted Legal Partner in {' '}
              <span className="text-[#c3a565]">Saudi Arabia</span>
            </motion.h1>
            
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-[#faf9f7]/70 max-w-[540px] mb-8 sm:mb-10 leading-relaxed text-base sm:text-lg"
              style={{ fontWeight: 300 }}
            >
              Navigating the Kingdom's legal landscape with precision, expertise, 
              and unwavering commitment to your success.
            </motion.p>
            <motion.a
            href='#contact'
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="flex flex-col gap-3 sm:gap-4"
              style={{
                display:'inline-block'
              }}
            >
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="flex gap-3 px-8 py-4 bg-[#c3a565] text-[#0a0a0a] rounded-lg text-base hover:bg-[#d4b676] transition-all duration-300 shadow-lg shadow-[#c3a565]/20 cursor-pointer text-center touch-manipulation"
                style={{ fontWeight: 600, width:"max-content" }}
              >
                <Calendar />
                Book Consultation
              </motion.button>
              
              {/* Secondary CTAs - Two Column on Mobile */}
              {/* <div className="grid grid-cols-2 gap-3">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="px-4 sm:px-6 py-4 border border-[#faf9f7]/20 text-[#faf9f7] rounded-lg text-sm hover:border-[#c3a565]/40 hover:bg-[#c3a565]/05 transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer touch-manipulation"
                  style={{ fontWeight: 600 }}
                >
                  <Download className="w-4 h-4" />
                  <span className="hidden sm:inline">Download</span>
                  <span className="sm:hidden">Brochure</span>
                </motion.button>
                
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="px-4 sm:px-6 py-4 border border-[#faf9f7]/20 text-[#faf9f7] rounded-lg text-sm hover:border-[#c3a565]/40 hover:bg-[#c3a565]/05 transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer touch-manipulation"
                  style={{ fontWeight: 600 }}
                >
                  <MessageCircle className="w-4 h-4" />
                  <span className="hidden sm:inline">Contact</span>
                  <span className="sm:hidden">Chat</span>
                </motion.button>
              </div> */}
            </motion.a>
          </div>

          <div ref={ref} className="grid grid-cols-2 gap-3 sm:gap-4">
            {stats.map((stat, index) => {
              const count = useCountUp(stat.value, 4000, isVisible);
              return (
                <motion.a
                  key={index}
                  href="#contact"
                  initial={{ opacity: 0, y: 30 }}
                  animate={isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
                  whileHover={{ y: -8 }}
                  className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-lg sm:rounded-xl p-4 sm:p-6 border border-[#c3a565]/20 hover:border-[#c3a565] hover:shadow-2xl hover:shadow-[#c3a565]/10 transition-all duration-500 group relative overflow-hidden"
                >
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#c3a565]/10 to-transparent"></div>
                  </div>
                  <div className="relative z-10">
                    <div
                      className="text-2xl sm:text-3xl lg:text-4xl mb-1 sm:mb-2 text-[#c3a565] group-hover:scale-110 transition-transform duration-500"
                      style={{ 
                         fontWeight: 700 }}
                    >
                      {count.toLocaleString()}{stat.suffix}
                    </div>
                    <div className="text-xs sm:text-sm text-[#faf9f7]/70 mb-3 sm:mb-4 leading-snug">
                      {stat.label}
                    </div>
                    <div className="h-[1px] w-full bg-gradient-to-r from-[#c3a565]/0 via-[#c3a565]/30 to-[#c3a565]/0 mb-2 sm:mb-3 group-hover:via-[#c3a565]/60 transition-colors duration-300"></div>
                    <motion.div
                      className="text-xs text-[#c3a565] inline-flex items-center gap-1"
                      style={{ fontWeight: 600 }}
                      whileHover={{ gap: 6 }}
                    >
                      Learn More
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="group-hover:translate-x-1 transition-transform duration-300">
                        <path d="M4 2L8 6L4 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </motion.div>
                  </div>
                </motion.a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};